const hasFocusedOption = ({ state, props, path }) => {
  const focusedOption = state.get(`selectr.${props.namespace}.focusedOption`)
  if (focusedOption === null) {
    return path.false()
  } else {
    return path.true({ focusedOption })
  }
}

hasFocusedOption.displayName = 'hasFocusedOption'
export default hasFocusedOption
